(function ($) {
  'use strict';

  /**
   * Menu Tray Controls
   */

  $('.js-menu-tray-toggle').menuTrayControls();

  $('.js-contact-tray-toggle').menuTrayControls({
    class_animate_in: 'is-animate-in--from-end',
    class_animate_out: 'is-animate-out--from-end',
  });

  // Fades in place over the menu tray rather than sliding, to match the
  // drill-down sub-panels. `animation_length` must track the 250ms
  // `nav-tray-fade-in` duration in `_menu-tray-wraps.scss` — it's what gates
  // clearing `inert` and moving focus into the tray.
  $('.js-alerts-tray-toggle').menuTrayControls({
    class_animate_in: 'is-animate-in--fade',
    class_animate_out: 'is-animate-out--fade',
    animation_length: 250,
  });


  /**
   * Mobile Menu — Drill-down Panel Navigation
   */

  // Target the main menu tray only, not the contact tray
  var $trayInner = $( '#mobile-menu-tray .mobile-tray-inner' );
  if ( ! $trayInner.length ) return;

  // Detach the sliding content, leave the search in place
  var $navSection = $trayInner.find( '.mobile-tray-section' ).detach();
  var $trayFooter = $trayInner.find( '.mobile-tray-footer' ).detach();
  var $search     = $trayInner.find( '.mobile-nav--search' );


  // --- Build DOM ---

  var $backBtn = $( '<button>', {
    type: 'button',
    class: 'mobile-nav-back',
  }).append(
    $( '<span>', { class: 'mobile-nav-back-icon', 'aria-hidden': 'true' } ),
    $( '<span>', { class: 'mobile-nav-back-label' } )
  );

  var $subList = $( '<ul>', { role: 'list', class: 'mobile-sub-list' } );

  // Main panel: nav section + utility footer slide together
  var $mainPanel = $( '<div>', {
    class: 'mobile-nav-panel mobile-nav-panel--main',
  }).append( $navSection, $trayFooter );

  // Sub panel: back button header + cloned sub-items
  var $subPanel = $( '<div>', {
    class: 'mobile-nav-panel mobile-nav-panel--sub',
    'aria-hidden': 'true',
  }).append(
    $( '<div>', { class: 'mobile-nav-panel-header' } ).append( $backBtn ),
    $subList
  );

  var $panels = $( '<div>', { class: 'mobile-nav-panels' } )
    .append( $mainPanel, $subPanel )
    .insertBefore( $search );

  // The sub-panel is only *visually* hidden (opacity: 0 in CSS), so `inert` is
  // what actually keeps its back button and cloned links out of the tab order
  // and the accessibility tree.
  $subPanel.prop( 'inert', true );

  function setHeight( $panel ) {
    $panels.height( $panel.outerHeight() );
  }

  setHeight( $mainPanel );


  // --- Interactions ---

  // Remembers which parent link opened the sub-panel, so focus can be returned
  // to it on the way back out.
  var $lastParentLink = null;

  function goToMain( restoreFocus ) {
    setHeight( $mainPanel );

    // Re-enable the main panel *before* disabling the sub-panel, so focus
    // always has somewhere valid to land.
    $mainPanel.attr( 'aria-hidden', 'false' ).prop( 'inert', false );

    if ( restoreFocus && $lastParentLink && $lastParentLink.length ) {
      $lastParentLink.trigger( 'focus' );
    }

    $subPanel
      .removeClass( 'is-sub-active' )
      .attr( 'aria-hidden', 'true' )
      .prop( 'inert', true );
  }

  // Drill into sub-panel when a parent link is clicked
  $mainPanel.on( 'click', '.menu-item-has-children > a', function (e) {
    e.preventDefault();

    var $item = $( this ).parent();

    $lastParentLink = $( this );

    var labelText = $( this ).text().trim();

    $backBtn.find( '.mobile-nav-back-label' ).text( labelText );

    // Accessible name leads with the visible label text so voice control can
    // target it (WCAG 2.5.3), then names the actual destination. The visible
    // text is the section you're *in*, not where the button goes — the
    // drill-down is only ever one level deep, so back is always the main menu.
    $backBtn.attr( 'aria-label', labelText + ', back to main menu' );

    var $subItems = $item.find( '> .sub-menu' ).children().clone();

    // WP menu items carry `id="menu-item-N"` and the originals stay in the
    // DOM, so cloning them verbatim duplicates those IDs.
    $subItems.removeAttr( 'id' ).find( '[id]' ).removeAttr( 'id' );

    $subList.empty().append( $subItems );

    setHeight( $subPanel );
    $subPanel
      .addClass( 'is-sub-active' )
      .attr( 'aria-hidden', 'false' )
      .prop( 'inert', false );

    // Move focus into the sub-panel *before* inert-ing the main panel —
    // inert-ing an ancestor of the focused element drops focus to <body>.
    $backBtn.trigger( 'focus' );

    $mainPanel.attr( 'aria-hidden', 'true' ).prop( 'inert', true );
  });

  // Back to main panel — wrapped rather than passed directly, since jQuery
  // would hand the event object in as `restoreFocus` (and it's truthy).
  $backBtn.on( 'click', function () {
    goToMain( true );
  });

  // Reset to main whenever the tray is closed. No focus restore here —
  // menuTrayControls already returns focus to the tray toggle button.
  $( '.js-menu-tray-toggle' ).on( 'click', function () {
    goToMain( false );
  });

})(jQuery);